import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import CheckDot from '../generic/checkDot'

import { greenBase, fontWeightSemibold, fontSizeSmall, fontSize2XSmall } from '../../constants/principles'
import { FlexDiv } from '../generic/Basics'
import { getTheme } from '../../constants/themes'
export default ({ text, subtext, isDesktop, show, showCheck = true, theme }) => {
  const { fontFamily, color: themeColor } = getTheme(theme) || {}
  return (
    <StepDiv isDesktop={isDesktop} show={show}>
      {show && (
        <>
          {showCheck ? (
            <CheckDot color={greenBase} size={isDesktop ? 32 : 16} show={show} themeColor={themeColor} />
          ) : (
            <LoadingDot size={isDesktop ? 32 : 16} />
          )}
          <TextContainer isDesktop={isDesktop}>
            <Title fontFamily={fontFamily}>{text}</Title>
            <SubTitle fontFamily={fontFamily}>{subtext}</SubTitle>
          </TextContainer>
        </>
      )}
    </StepDiv>
  )
}
const TextContainer = styled(FlexDiv)`
  text-align: center;
  align-items: ${p => (p.isDesktop ? 'center' : 'flex-start')};
`
const Title = styled.div`
  font-weight: ${fontWeightSemibold};
  font-size: ${fontSizeSmall};
  margin-top: ${p => (p.isDesktop ? '32' : '0')}px;
  ${p => (p.fontFamily ? `font-family: ${p.fontFamily};` : '')};
`
const SubTitle = styled.div`
  font-size: ${fontSize2XSmall};
  ${p => (p.fontFamily ? `font-family: ${p.fontFamily};` : '')};
`

const fade = keyframes`
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
`

const spin = keyframes`
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
`

const StepDiv = styled.div`
  display: flex;
  flex-direction: ${p => (p.isDesktop ? 'column' : 'row')};
  justify-content: ${p => (p.isDesktop ? 'center' : 'flex-start')};
  align-items: center;
  padding: 0px 16px 32px 16px;
  -webkit-animation: ${fade} 0.75s linear;
  animation: ${fade} 0.75s linear;
  width: ${p => (p.isDesktop ? 33 : 100)}%;
`

const LoadingDot = styled.div`
  width: ${p => (p.size ? p.size * 0.75 : 12)}px;
  height: ${p => (p.size ? p.size * 0.75 : 12)}px;
  margin: 0px 4px;
  @media (min-width: 768px) {
    width: ${p => (p.size ? p.size : 16)}px;
    height: ${p => (p.size ? p.size : 16)}px;
    margin: 0px 8px;
  }
  border-radius: 50%;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #2196F3;
  animation: ${spin} 1s linear infinite;
`
